// extracted by mini-css-extract-plugin
export default {"search":"search_search__kx-dF","search-icon":"search_search-icon__oCcZt"};